import { render } from "./ExpenseHeadCreate.vue?vue&type=template&id=d2bfc4ca"
import script from "./ExpenseHeadCreate.vue?vue&type=script&lang=js"
export * from "./ExpenseHeadCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__